import Instance from "../../../../Axios";

// New Actions for the app

const DeleteFabricante = (id) => async (dispatch) => {
  await Instance()
    .put(`/energias/fabricantes/${id}`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: "DELETE_FABRICANTE", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default DeleteFabricante;